// src/resources/config.ts
import type { ResourceConfig } from "./resourceTypes";

import {
  CA_CONFIG,
  CRON_CONFIG,
  DATA_CONFIG,
  DNS_CONFIG,
  IAM_CONFIG,
  IPAM_CONFIG,
  MONITOR_CONFIG,
  PROJECT_CONFIG,
  SSH_CONFIG,
  HOST_CONFIG,
  AUTH_CONFIG,
  WIKI_CONFIG,
  AUTOMATION_CONFIG,
} from "./sections";

export const RESOURCES: ResourceConfig[] = [
  ...CA_CONFIG,
  ...CRON_CONFIG,
  ...DATA_CONFIG,
  ...DNS_CONFIG,
  ...IAM_CONFIG,
  ...IPAM_CONFIG,
  ...MONITOR_CONFIG,
  ...PROJECT_CONFIG,
  ...SSH_CONFIG,
  ...HOST_CONFIG,
  ...AUTH_CONFIG,
  ...WIKI_CONFIG,
  ...AUTOMATION_CONFIG,
];

export type { ResourceConfig } from "./resourceTypes";
